import React, { ReactElement } from 'react';

import Link from 'atomic/link/link';
import Icon from 'atomic/icon/icon';
import type { ReviewProductInterface } from 'modules/review/review.interface';

import './review-item-product.desktop.scss';

interface ReviewItemProductProps {
    product: ReviewProductInterface;
    content: string;
}

const ReviewItemProductDesktop: React.FC<ReviewItemProductProps> = ({ product, content }): ReactElement => {
    const productName = `${product.brand} ${product.model}`;

    return (
        <div className="review-item__product">
            <div className="review-item__product-image">
                {product.thumb ? <img src={product.thumb} alt={productName} /> : <Icon icon="no-image" className="review-item__product-no-image" />}
            </div>
            <div className="review-item__product-content">
                {
                    product.id
                        ? (
                            <Link href={`/opinie-${product.id}-${product.slug}.html`} className="review-item__product-name">
                                {productName}
                            </Link>
                        )
                        : (
                            <span className="review-item__product-name">
                                {productName}
                            </span>
                        )
                }
                <div className="review-item__product-text">
                    {content}
                </div>
            </div>
        </div>
    );
};

export default ReviewItemProductDesktop;
